import React from 'react'
import {Link, useParams} from 'react-router-dom'
import styles from "../Archives.module.css";
import {toUrlSlug} from "../../../Components/Helpers/toUrlSlug";

const ArchivesElement = ({ article, imageUrl, translation, dataCount }) => {

    const { name, street, postCode, area, headline  } = article;
    const {lang} = useParams()

    return (
        <div className={styles.box}>
            <img src={imageUrl} alt={article.alt_image} className={styles.img}/>
            <div className={styles.item}>
                <h2 className={styles.name}>{name}</h2>
                <div className={styles.street}>{street} {postCode} {area}</div>
                <div className={styles.counter}>{dataCount !== "" ? `${dataCount.count_items} ${translation.archives.objects} ${dataCount.count_items_images} ${translation.archives.scans}` : ""}</div>
                <div className={styles.txt} dangerouslySetInnerHTML={{__html: headline}}/>
                <div className={styles.buttonsWrapper}>
                    <Link to={`/${lang}/lokalizacje/${article.id}-${toUrlSlug(name)}/szczegoly`}
                          className={styles.button}
                          title={`${translation.wcagLabels.lokalizacje.goToDetails} - "${name}"`}
                          aria-label={`${translation.wcagLabels.lokalizacje.goToDetails} - "${name}"`}
                    >{translation.archives.more}</Link>
                    <Link to={`/${lang}/lokalizacje/${article.id}-${toUrlSlug(name)}`}
                          className={styles.button}
                          title={`${translation.wcagLabels.lokalizacje.goToList} - "${name}"`}
                          aria-label={`${translation.wcagLabels.lokalizacje.goToList} - "${name}"`}
                    >{translation.archives.goToCollection}</Link>
                </div>
            </div>
        </div>
    );
};

export default ArchivesElement;

	
